var MobileModeChangeSource = /*#__PURE__*/function (MobileModeChangeSource) {
  MobileModeChangeSource["User"] = "user";
  MobileModeChangeSource["Browser"] = "browser";
  return MobileModeChangeSource;
}(MobileModeChangeSource || {});

export { MobileModeChangeSource as M };
//# sourceMappingURL=MobileModeChangeSource-CL9HhYGS.js.map
